import { render } from "./ForgotOTP.vue?vue&type=template&id=a0c1aef4"
import script from "./ForgotOTP.vue?vue&type=script&lang=js"
export * from "./ForgotOTP.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__